export let scrollHeaderMinxin = {
  data () {
    return {
      pageTitle: ''
    }
  },
  created () {
    this.navBar().transChild = true
    window.addEventListener('scroll', this.pageScroll)
  },
  destroyed () {
    this.navBar().title = ''
    this.navBar().$el.style.backgroundColor = 'transparent'
    window.removeEventListener('scroll', this.pageScroll)
  },
  methods: {
    pageScroll (event) {
      let scrollPosition = Math.round(window.scrollY)

      let header = this.$refs.header
      let navBar = this.navBar().$el
      let scrollEndPosition = header.clientHeight - navBar.clientHeight

      if (scrollPosition > scrollEndPosition) {
        navBar.style.backgroundColor = '#06b782'
        this.navBar().title = this.pageTitle
      } else {
        navBar.style.backgroundColor = '#06b782'
        navBar.style.backgroundColor = 'transparent'
        this.navBar().title = ''
      }
    }
  }
}
